import { ThemeConfig } from "@/types/theme";
import { DEFAULT_THEME } from "@/components/ui/theme-config-provider";

/**
 * Returns the most readable text color from the theme based on the provided background color.
 */
export const getContrastTextColor = (
  theme: ThemeConfig,
  hexColor?: string
): string => {
  if (!hexColor || !hexColor.startsWith("#")) {
    return theme.textColor || DEFAULT_THEME.textColor;
  }

  const hex = hexColor.replace("#", "");
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5
    ? theme.textColor || DEFAULT_THEME.textColor
    : theme.textColor || DEFAULT_THEME.textColor;
};

export const isHexColorDark = (hexColor?: string): boolean => {
  if (!hexColor || !hexColor.startsWith('#')) return false;
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance < 0.5;
};

export const getThemeVariable = (name: string): string => {
  if (typeof document === 'undefined') return '';
  return (
    getComputedStyle(document.documentElement)
      .getPropertyValue(`--${name}`)
      .trim() || ''
  );
};
